import React, { useState } from "react";
import ImageWidgetUploadInput from "../../../../../../parts/inputs/image-widget-upload";

export const EditStore = ({
  _idProps,
  urlProps,
  widgetProps,
  imageProps,
  setAddNew,
  setEditStoreState,
}) => {
  const [urlState, setUrlState] = useState({
    url: urlProps || "",
    widget: widgetProps,
    _id: _idProps,
    image: imageProps,
  }); //state to control the store's edit form

  /**
   * Validate if edit form is valid
   * @returns
   */
  const validationStoreSubmit = () => {
    if (urlState.url.length > 0) {
      return true;
    }
    return false;
  };

  /**
   * assign the value to the add new store state
   * @param {*} param0
   */
  const handleInputStoreChange = ({ target }) => {
    const newState = Object.assign({}, urlState, {
      [target.name]: target.value,
    });
    setUrlState(newState);
  };

  return (
    <form
      encType="multipart/form-data"
      method="POST"
      data-noreset
      action={`/actions/stores/save${urlState?._id ? "/" + urlState._id : ""}`}
      className="add-edit-store-wrapper"
    >
      <ImageWidgetUploadInput
        name="image"
        prefix="Video playlist"
        defaultValue={urlState.image}
        backgroundedit={`${
          urlState.image?.s3Path ? urlState.image?.s3Path : ""
        }`}
        hasImage={urlState.image?.s3Path ? true : false}
      />
      <div>
        <div className="input-box">
          <label> Store URL </label>
          <input
            name="url"
            className="text-input"
            placeholder={`Paste the URL here..`}
            value={urlState.url}
            onChange={handleInputStoreChange}
          />
          <input
            name="widget"
            style={{ display: "none" }}
            defaultValue={urlState.widget}
          />
        </div>
        <div className="flex flex-row gap-2">
          <button
            data-button-type="primary"
            disabled={!validationStoreSubmit()}
          >
            Save
          </button>
          <button
            data-button-type="text-white"
            data-action="cancel"
            onClick={(e) => {
              e.preventDefault();
              if (setAddNew) {
                setAddNew("addNewButton");
              } else {
                setEditStoreState("");
              }
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};
